module.exports = __webpack_public_path__ + "img/varied_lights_3.f9914c90.png";